import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import SearchRecords from "../components/EligibilityCheck/SearchRecords";
import { ApplicationState } from "../../../store/ApplicationState";
import { postAllPatientRecord } from "../../../actions/AllPatientRecords";
import { AllPatientDispatchTypes } from "../../../models/DispatchTypes/AllPatientRecord";
import { SearchPayloadForRecords } from "../../../models/Authorization";

const mapStateToProps = ({
    allPatientRecordState,
}: ApplicationState) => ({
    allPatientRecord: allPatientRecordState,
});

type DispatchTypes = AllPatientDispatchTypes

const mapDispatchToProps = (
    dispatch: ThunkDispatch<
        ApplicationState,
        Record<string, never>,
        DispatchTypes
    >
) => {
    return {
        postAllPatientRecord: (payload?: SearchPayloadForRecords) => {
            dispatch(postAllPatientRecord(payload));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SearchRecords);